'use client'
import React from 'react'

import useRoadViewViewModel from '@/components/roadview/components/kakaoRoadview/viewModel'

interface KakaoRoadViewProps {
  latitude: number
  longitude: number
  setIsRoadviewFail: React.Dispatch<React.SetStateAction<boolean>>
}

const KakaoRoadview = ({ latitude, longitude, setIsRoadviewFail }: KakaoRoadViewProps) => {
  useRoadViewViewModel({ lat: latitude, lng: longitude, setIsRoadviewFail })

  return <div id="roadview" style={{ width: '100%', height: '100%' }} />
}

export default KakaoRoadview
